module.exports = __webpack_public_path__ + "61df58e7cd76fa286ac82cb8c8f0b7c9.pdf";